module.exports = __webpack_public_path__ + "img/menu-hair-3.bef45d7e.webp";